import React from 'react';
import { FaPlus, FaChartLine, FaCog, FaBell, FaDownload, FaShare } from 'react-icons/fa';

const QuickActions = ({ onActionClick }) => {
  const actions = [
    {
      id: 'create-strategy',
      title: 'Create Strategy',
      description: 'Build a new trading strategy',
      icon: <FaPlus />,
      color: '#4DD5B8',
      action: () => onActionClick && onActionClick('create-strategy')
    },
    {
      id: 'view-analytics',
      title: 'Analytics',
      description: 'View detailed performance metrics',
      icon: <FaChartLine />,
      color: '#FF823C',
      action: () => onActionClick && onActionClick('view-analytics')
    },
    {
      id: 'settings',
      title: 'Settings',
      description: 'Configure your preferences',
      icon: <FaCog />,
      color: '#6c757d',
      action: () => onActionClick && onActionClick('settings')
    },
    {
      id: 'notifications',
      title: 'Notifications',
      description: 'Manage alerts and updates',
      icon: <FaBell />,
      color: '#FFC833',
      action: () => onActionClick && onActionClick('notifications')
    },
    {
      id: 'export-data',
      title: 'Export Data',
      description: 'Download your trading data',
      icon: <FaDownload />,
      color: '#17a2b8',
      action: () => onActionClick && onActionClick('export-data')
    },
    {
      id: 'share',
      title: 'Share',
      description: 'Share strategies with team',
      icon: <FaShare />,
      color: '#28a745',
      action: () => onActionClick && onActionClick('share')
    }
  ];

  return (
    <div className="quick-actions-container" style={{
      background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
      borderRadius: '10px',
      padding: '12px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.06)',
      border: '1px solid #e9ecef'
    }}>
      <div className="d-flex align-items-center mb-2">
        <h4 className="mb-0 fw-bold" style={{ color: '#151B22', fontSize: '16px' }}>
          Quick Actions
        </h4>
        <div style={{
          width: '30px',
          height: '2px',
          background: 'linear-gradient(90deg, #4DD5B8 0%, #FF823C 100%)',
          borderRadius: '2px',
          marginLeft: '8px'
        }} />
      </div>

      <div className="row g-2">
        {actions.map((action) => (
          <div key={action.id} className="col-md-6 col-lg-4">
            <div 
              className="quick-action-card"
              onClick={action.action}
              style={{
                background: '#ffffff',
                borderRadius: '8px',
                padding: '12px',
                border: '1px solid #e9ecef',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '2px',
                  background: action.color
                }}
              />
              
              <div className="d-flex align-items-center mb-2">
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  background: `${action.color}15`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: action.color,
                  fontSize: '14px',
                  marginRight: '10px'
                }}>
                  {action.icon}
                </div>
              </div>

              <h6 className="mb-0 fw-semibold" style={{ color: '#151B22', fontSize: '12px' }}>
                {action.title}
              </h6>
              
              <p className="mb-0 mt-1" style={{ 
                color: '#495057', 
                fontSize: '10px',
                lineHeight: '1.3'
              }}>
                {action.description}
              </p>

              <style jsx>{`
                .quick-action-card:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.1);
                  border-color: ${action.color}40;
                }
                
                .quick-action-card:hover > div:first-child {
                  background: ${action.color} !important;
                }
              `}</style>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
